export default {
  common: {
    home: 'Home',
    loading: 'Loading...',
    allNews: 'All news',
    goToSite: 'Go to site',
    language: 'Language',
    menu: 'Menu',
    notFound: 'Article not found.',
    backToList: 'Back to the list',
    orgName: 'Republican Scientific and Methodological Center for the Development of Education of the Republic of Uzbekistan',
    testMode: 'The site is running in test mode',
    newsNotFound: 'News not found.',
    gerbAlt: 'Coat of arms of the Republic of Uzbekistan',
    views: 'Views',
    soon: 'Soon'
  },

  nav: {
    markaz: 'Center',
    faoliyat: 'Activities',
    hujjatlar: 'Documents',
    axborot: 'Information service',
    pisa: 'PISA',
    boglanish: 'Contact',

    markazHaqida: 'About the center',
    rahbariyat: 'Leadership',
    boshqarmaBoshliqlari: 'Heads of departments',
    tuzilma: 'Structure',

    oquvMetodik: 'Educational-normative and methodological coordination of education',
    baholashMonitoring: 'Assessment and monitoring of education quality',
    raqamliSavodxonlik: 'Introducing digital literacy and innovative technologies',
    talimNormativlari: 'Pedagogical-psychological support of education',
    hisobotlar: 'Reports',

    prezidentFarmonlari: 'Presidential decrees, orders and resolutions',
    talimgaOidQonunlar: 'Laws on education',
    vazirlarMahkamasi: 'Resolutions of the Cabinet of Ministers',
    markazFaoliyati: "Documents on the center's activities",
    talimgaDoirHujjatlar: 'Documents on education',

    yoshOlimlar: 'School of young scientists and researchers',
    savolJavob: 'Questions and answers',
    ochiqMalumotlar: 'Open data',
    yangiliklar: 'News',
    galereya: 'Gallery',
    ilmiyMaqolalar: 'Scientific articles',

    ilmiyMetodik: 'Research, Methodology and International Cooperation',
    ilmiyMetodikFaoliyat: 'Research and methodology',
    xalqaroHamkorlik: 'International cooperation',
    ilmiyLoyihalar: 'Research projects'
  },

  footer: {
    copyright: '© 2026. When using the materials in full or in part, a reference to the source trm.uz is required.',
    callAria: 'Call: {phone}',
    emailAria: 'Send email: {email}'
  },

  a11y: {
    title: 'Accessibility',
    close: 'Close',
    fontSize: 'Font size:',
    zoom: 'Zoom:',
    screenReader: 'Screen reader:',
    toggle: 'On / Off',
    maleVoice: 'Male voice',
    femaleVoice: 'Female voice',
    readerHint: 'When enabled, click on the text you want read aloud.',
    googleTranslate: 'Google Translate:',
    selectLanguage: 'Select language',
    readingMode: 'Reading mode',
    reset: 'Reset to defaults',
    modeDefault: 'Default',
    modeInvert: 'Invert colors',
    modeContrast: 'Contrast',
    modeGray: 'Grayscale'
  },

  pager: {
    label: 'Pages',
    first: 'First page',
    prev: 'Previous page',
    next: 'Next page',
    last: 'Last page'
  },

  lightbox: {
    prev: 'Previous',
    next: 'Next'
  },

  home: {
    heroTitle: 'Towards improving the quality of education',
    heroSubtitle: 'A center working to develop the content and methodology of education and the monitoring of its quality',

    featureOquvMetodik: 'Educational-normative and methodological coordination of education',
    featureBaholash: 'Assessment and monitoring of education quality',
    featureNormativlar: 'Pedagogical-psychological support of education',
    featureRaqamli: 'Introducing digital literacy and innovative technologies',

    newsTitle: 'News and announcements',

    prezidentQuote: 'Both the cornerstone of progress and the force that makes a country mighty and a nation great are science, education and upbringing.',
    prezidentName: 'Shavkat Mirziyoyev',
    prezidentRole: 'President of the Republic of Uzbekistan',

    statMaktabgacha: 'Preschool education institutions',
    statUmumiy: 'General secondary education institutions',
    statKasbiy: 'Secondary specialized and vocational education institutions',
    statOliy: 'Higher education institutions',

    mediaTitle: 'Media',
    mediaPhotos: 'Photos',
    mediaVideos: 'Videos',
    mediaNoVideos: 'No videos available yet.',
    mediaNoPhotos: 'No photos available yet.',
    mediaPlay: 'Play video',

    portalTitle: 'Unified portal of digital educational resources and services',
    portalSubtitle: 'An ecosystem of methodological support in education',

    linksTitle: 'Useful links',
    linkIma: 'Agency for Specialized Educational Institutions',
    linkGov: 'Government Portal of the Republic of Uzbekistan',
    linkUzedu: 'Ministry of Preschool and School Education',
    linkOliy: 'Ministry of Higher Education, Science and Innovation'
  },

  pages: {
    comingSoon: {
      title: 'Soon',
      text: 'This section is being prepared. Its content will be published soon.'
    },

    hisobotlar: {
      intro: 'Quarterly, half-year and annual reports on the Centre’s activities.',
      typeFilter: 'Report type',
      yearFilter: 'Year',
      all: 'All',
      quarterly: 'Quarterly',
      halfYear: 'Half-year',
      annual: 'Annual',
      allYears: 'All years',
      periods: { q1: 'Q1', q2: 'Q2', q3: 'Q3', q4: 'Q4', h1: 'H1', h2: 'H2', year: 'Annual' },
      yearLabel: '{year}',
      empty: 'No reports have been published yet.',
      noMatch: 'No reports found for the selected period.',
      resetFilters: 'Clear filters',
      download: 'Download the report',
      attachment: 'Attachment',
      notFound: 'Report not found.',
      others: 'Other reports',
      kpiTotal: 'Total reports',
      kpiPublished: 'Published',
      kpiPending: 'Pending',
      progress: '{year} by quarter',
      legendDone: 'Published',
      legendNow: 'Current quarter',
      legendWait: 'Pending',
      search: 'Search reports',
      preparing: 'In preparation',
      downloadShort: 'Download',
      more: 'Details',
      count: '{n} reports',
      range: '{from} — {to} {year}',
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    },

    ochiqMalumotlar: {
      openFile: 'open file'
    },

    oquvMetodik: {
      figAlt1: 'Educational and methodological complexes — completed work (1)',
      figAlt2: 'Educational and methodological complexes — completed work (2)',
      blocks: [
        { type: 'lead', text: 'Department for Educational-Normative and Methodological Coordination of Education' },
        { type: 'label', text: 'The department includes the following divisions:' },
        { type: 'list', items: [
          'Division for Implementing Educational Programs and Educational-Methodological Complexes',
          'Division for Expert-Analytical Services'
        ] },
        { type: 'section', text: "Tasks and functions of the department" },
        { type: 'list', items: [
          'coordinating the processes of developing, analyzing and introducing educational-normative documents, curricula and programs, and educational-methodological complexes in the field of education, and ensuring their implementation in practice;',
          'developing the requirements for the educational standards, curricula and programs of preschool, general secondary and out-of-school education institutions, as well as short-term, including private, training courses;',
          'improving teaching methods in preschool, general secondary and out-of-school education institutions, and coordinating the publication and practical introduction of new educational-methodological complexes based on modern requirements and advanced foreign experience;',
          'organizing systematic scientific-methodological work on piloting educational-methodological complexes, subjecting them to scientific expert review, analyzing the obtained results and improving them;',
          "developing expert-analytical activity in the field of education, preparing expert opinions on curricula, methodological guides, textbooks and other educational-methodological products, and developing scientifically grounded methodological recommendations;",
          'coordinating the activities of the Scientific-Methodological Councils by subject area established under the Center;',
          'conducting analytical and applied research aimed at developing the education sector, and preparing scientific developments and recommendations on the wide use of the achievements of world science and technology in the educational process;',
          'implementing scientific-practical initiatives on improving the content of education in cooperation with international organizations, scientific centers and advanced foreign publishers, and ensuring the study of advanced foreign experience and its adaptation to local practice.'
        ] }
      ]
    },

    markazHaqida: {
      title: 'REPUBLICAN SCIENTIFIC AND METHODOLOGICAL CENTER FOR THE DEVELOPMENT OF EDUCATION',
      tasksTitle: 'THE CENTER’S MAIN TASKS:',
      tasks: [
        'introducing innovative pedagogical technologies, effective forms and methods of teaching, and modern systems for assessing and monitoring the quality of education into the educational process;',
        'developing and approving requirements for the educational standards, curricula and programs of preschool, general secondary and out-of-school education institutions, as well as short-term, including private, training courses (hereinafter — training courses);',
        'improving teaching methods in educational institutions, publishing new textbooks and educational-methodological complexes based on modern requirements and advanced foreign experience, and organizing their piloting and expert review;',
        'introducing advanced forms of training, retraining and professional development of the managerial and pedagogical staff of educational institutions, and creating conditions for the continuous improvement of teachers’ professional skills;',
        'participating in the monitoring of the quality of the teaching-and-upbringing process and staff training in educational institutions, analyzing the compliance of students’ knowledge with educational standards and requirements, and organizing international programs and studies on education quality in the Republic of Uzbekistan;',
        'conducting analytical and applied research aimed at developing the education sector, and preparing scientific developments and recommendations on the wide use of the achievements of world science and technology in the educational process;',
        'studying and systematically analyzing best practices in the field of education, adopting a set of measures for their implementation in the republic, and developing ties with leading foreign research organizations.',
        'the requirements for educational standards, curricula and programs developed and approved by the republican center are mandatory for preschool, general secondary and out-of-school education institutions, as well as training courses;'
      ]
    },

    tuzilma: {
      heading: 'Structure of the Republican Scientific and Methodological Center for the Development of Education',
      annex: 'ANNEX to Resolution of the President of the Republic of Uzbekistan No. PP-128 of April 20, 2023',
      staff: 'Total number of staff — 42, including management staff — 15, research staff — 27.',
      revision: '(text of the annex as amended by Decree of the President of the Republic of Uzbekistan No. UP-197 of October 29, 2025)',
      director: 'Director',
      advisors: 'Advisors',
      deputy: 'Deputy Director',
      board1: 'Department for Educational-Normative and Methodological Coordination of Education',
      b1u1: 'Division for Implementing Educational Programs and Educational-Methodological Complexes',
      b1u2: 'Division for Expert-Analytical Services',
      board2: 'Department for Pedagogical-Psychological Support of Education',
      b2u1: 'Division for the Development of Pedagogical Skills and Inclusive Education',
      b2u2: 'Division for the Development of Psychological Service and Career Guidance',
      board3: 'Department for Assessment and Monitoring of Education Quality',
      b3u1: 'Division for Assessment and Social-Applied Research',
      b3u2: 'Division for the Analysis of Indicators in International Programs and Rankings',
      board4: 'Department for Introducing Digital Literacy and Innovative Technologies',
      b4u1: 'Division for the Development of Digital Pedagogy and Media Education',
      b4u2: 'Division for Introducing Digital Technologies and Innovations',
      s1: 'Information Service',
      s2: 'Accounting Division',
      s3: 'Division for Coordinating Scientific-Methodological Activity and International Cooperation',
      s4: 'Human Resources Development Service',
      s5: 'Service for Performance Discipline and Handling Appeals',
      s6: 'Legal Counsel',
      s7: 'Chief ICT Specialist'
    },

    contact: {
      title: 'If you have any question or suggestion, you can write to us',
      address: 'Tashkent, Navoiy street, 30',
      mapTitle: 'Center location',
      formTitle: 'Send a message',
      name: 'Your name',
      phone: 'Your phone number',
      email: 'E-mail',
      subject: 'Subject',
      choose: 'Choose',
      message: 'Message',
      send: 'Send',
      sending: 'Sending...',
      sent: 'Your message has been sent. We will reply soon.',
      topicGeneral: 'General question',
      topicSuggestion: 'Suggestion',
      topicComplaint: 'Complaint',
      topicCooperation: 'Cooperation',
      errName: 'Please enter your name.',
      errMessage: 'The message must contain at least 5 characters.',
      errPhone: 'Please enter the full phone number (+998 and 9 digits).',
      errSend: 'Could not send the message. Check your internet connection and try again.'
    },

    ilmiy: {
      head: 'List of scientific works published by the staff of the Republican Scientific and Methodological Center for the Development of Education',
      colNo: 'No.',
      colName: 'Full name',
      colTopic: 'Topic of scientific work',
      colUrl: 'URL address (link)',
      goToLink: 'Go to link',
      noLink: 'No link',
      filterAll: 'All',
      filterInternational: 'International',
      filterLocal: 'Local',
      filterScopus: 'Scopus / WoS',
      filterNew: 'Newly added',
      badgeNew: 'New',
      emptyList: 'No data found'
    },

    baholash: {
      blocks: [
        { type: 'lead', text: 'Department for Assessment and Monitoring of Education Quality' },
        { type: 'label', text: 'The department includes the following divisions:' },
        { type: 'list', items: [
          'Division for Assessment and Social-Applied Research',
          'Division for the Analysis of Indicators in International Programs and Rankings'
        ] },
        { type: 'section', text: "Tasks and functions of the department" },
        { type: 'list', items: [
          'identifying compliance with state educational standards and the factors affecting the quality of education in preschool, general secondary and out-of-school education institutions, and carrying out systematic monitoring;',
          'coordinating the processes of licensing, attestation and state accreditation of preschool, general secondary and out-of-school education institutions, as well as training courses;',
          'monitoring the quality of the teaching-and-upbringing process and staff training in educational institutions, analyzing the compliance of students’ knowledge with standards, and introducing modern assessment systems;',
          'collecting systematic data, conducting social-applied research and preparing scientifically grounded proposals for evidence-based decision-making in the field of education;',
          'regularly analyzing the effectiveness of educational standards, curricula, programs and textbooks, and developing recommendations for their improvement;',
          'ensuring participation in international programs and studies assessing students’ educational achievements (PISA, PIRLS, TIMSS, TALIS) and assisting in improving indicators in the rankings;',
          'establishing cooperative ties with international organizations, universities and scientific centers, and, based on research results, improving teachers’ qualifications and introducing advanced international benchmarking practices;',
          'widely promoting international and national assessment results in the mass media and on social networks, and preparing and publishing scientific articles on the sector’s activities;',
          'participating, in cooperation with authorized bodies, in developing criteria for assessing the activities of educational institutions.'
        ] }
      ]
    },

    raqamli: {
      blocks: [
        { type: 'lead', text: 'Department for Introducing Digital Literacy and Innovative Technologies' },
        { type: 'label', text: 'The department includes the following divisions:' },
        { type: 'list', items: [
          'Division for the Development of Digital Pedagogy and Media Education',
          'Division for Introducing Digital Technologies and Innovations'
        ] },
        { type: 'section', text: "Tasks and functions of the department" },
        { type: 'list', items: [
          'developing and introducing programs, projects, methodological materials and educational-methodological complexes aimed at raising digital literacy in the education system and developing the digital competencies and skills of education participants;',
          'integrating digital pedagogy, media education and modern teaching technologies into the educational process, and studying advanced foreign experience in the field and adapting it to local conditions;',
          'developing methodological recommendations, educational-methodological guides and instructions on the ethics of using artificial intelligence technologies, data privacy and information security in the educational process;',
          'forming a system for using virtual and augmented reality (VR/AR), simulators, interactive platforms and other innovative digital technologies in the educational process, and implementing pilot projects to assess their effectiveness;',
          'creating digital learning content (video lessons, interactive activities, multimedia resources, learning platforms) for preschool and school education institutions, and assisting in the methodological and technical expert review of its quality;',
          'introducing innovative solutions and digital management mechanisms into the activities of educational institutions, providing scientific-methodological support for automating processes, and preparing analytical conclusions;',
          'introducing digital education platforms, databases and learning-process management systems (LMS, LXP, LRS), and conducting scientific-methodological research on ensuring their continuous and effective operation;',
          'developing methodological and organizational solutions for introducing EdTech, electronic educational resources, virtual laboratories and simulators in education, and assessing and improving the technologies in use;',
          'preparing content, educational-methodological complexes and methodological materials for short-term professional-development courses, trainings and webinars on developing teachers’ digital competencies;',
          'conducting analytical and scientific-practical research in the field of digital education, media education and innovations, and developing strategic proposals and recommendations for the sector’s development based on research results;',
          'implementing joint programs and international grant projects on introducing digital education and innovative technologies in cooperation with international organizations, donors and technology companies, and coordinating relevant initiatives.'
        ] }
      ]
    },

    normativ: {
      blocks: [
        { type: 'lead', text: 'Department for Pedagogical-Psychological Support of Education' },
        { type: 'label', text: 'The department includes the following divisions:' },
        { type: 'list', items: [
          'Division for the Development of Pedagogical Skills and Inclusive Education',
          'Division for the Development of Psychological Services and Career Guidance'
        ] },
        { type: 'section', text: "Tasks and functions of the department" },
        { type: 'list', items: [
          'providing scientific-methodological support for pedagogical and psychological assistance in the preschool, general secondary and out-of-school education system, supporting the professional development of pedagogical and psychological staff, and improving the system of inclusive education and career guidance;',
          'studying advanced national and international experience, introducing modern approaches, and preparing scientific-methodological developments that serve to form a safe, inclusive and developmental learning environment for education participants;',
          'improving the system of pedagogical and psychological support of education and professional development of staff on the basis of advanced experience and research;',
          'introducing innovative paradigms and methodologies into the teaching-and-upbringing process, forming an ideological immunity in education participants, and improving the mechanisms for creating an inclusive, psychologically stable and developmental learning environment;',
          'defining the requirements for the activities of pedagogical staff, developing them professionally, and introducing values and ideological practices based on humanism, the sustainable development of the personality and social cooperation, and the ideas of inclusiveness, as well as effective educational strategies;',
          'coordinating the activities of psychologists, developing them professionally, introducing modern practices and technologies and advanced experience, and providing methodological support for creating an environment of psychological well-being, trust and development in education;',
          'preparing scientific developments and recommendations on the wide use of the achievements of world science and technology in the educational process;',
          'providing strategic support for continuous education and systematically carrying out career guidance, forming sustainable lifelong-learning skills, and developing and introducing career-guidance models, programs, and individual educational and career trajectories in line with the real demands of the labor market.'
        ] }
      ]
    }
  }
}
